import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";

// Keeps the router location in the redux store, so actions can navigate with push().
export const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory()
});
